export default "__VITE_ASSET__Bb9sgD6D__"